import { Vertical } from 'enums';
import * as React from 'react';
import { AppStore } from '../../../../stores/App.store';
import { AdvancedPlansFeatureSection } from 'types';
import { getRecommendedSectionDataFromDealerOffers } from 'utils';

export const UseGridSections = (
  sections: AdvancedPlansFeatureSection[],
  appStore: AppStore,
) => {
  const {
    appContext: { verticalName, biLogger, siteGuid, parsedDealerOffers },
    planType,
    isSecondUpgrade,
    isUseDealerIntegrationIntentElementsEnabled,
  } = appStore;
  const [areSectionsFolded, setSectionsFolded] = React.useState(false);
  let openedSections = sections,
    foldedSections: AdvancedPlansFeatureSection[];

  if (isUseDealerIntegrationIntentElementsEnabled) {
    const { recommendedSection } = getRecommendedSectionDataFromDealerOffers(
      parsedDealerOffers,
      isSecondUpgrade,
    );
    openedSections = sections
      .filter((section) => section.category === recommendedSection)
      .sort((section) => (section.category === recommendedSection ? -1 : 0));

    foldedSections = sections.filter(
      (section) => !(section.category === recommendedSection),
    );
  } else {
    openedSections = openedSections.filter(
      (section) =>
        section.intent.includes(verticalName as Vertical) ||
        section.isAscend ||
        (section.alwaysOpened && verticalName === Vertical.Default),
    );

    // first take ascend section to be first
    openedSections = openedSections
      .sort((section) => {
        if (section.isAscend) {
          return -1;
        }
        return 0;
      })
      // then bring all intent sections before ascend while maintaining their order
      .sort((section1, section2) => {
        if (
          section1.intent.includes(verticalName as Vertical) &&
          section2.intent.includes(verticalName as Vertical)
        ) {
          return 0;
        }
        if (section1.intent.includes(verticalName as Vertical)) {
          return -1;
        }
        if (section2.intent.includes(verticalName as Vertical)) {
          return 1;
        }
        return 0;
      });

    foldedSections = sections.filter(
      (section) =>
        !section.intent.includes(verticalName as Vertical) && !section.isAscend,
    );
  }

  const toggleSections = () => {
    biLogger.logClickOnShowAllFeatures({
      ppType: planType,
      siteGuid,
      clickType: areSectionsFolded ? 'hide' : 'show',
    });
    setSectionsFolded((prev) => !prev);
  };

  return { openedSections, foldedSections, toggleSections, areSectionsFolded };
};
